import PrimaryButton from "../../../components/primaryButton";

const Footer = () => {
  return (
    <div className="w-full px-4">
      <div className="flex flex-col items-center ">
        <p className="text-[32px] font-bold">
          BACKED BY
        </p>
        <div className="flex justify-between w-[331px]">
          <img src="/credpoints/footer/bixin.svg" className="w-20 h-20" />
          <img src="/credpoints/footer/aptos.svg" className="w-[200px]" />
        </div>
      </div>
    </div>
  );
};

export default Footer;
